import { UnitTransferReasonEnumType } from '__generated__/graphql';

export default function unitTransferReasonToReadable(reason: UnitTransferReasonEnumType): string {
  switch (reason) {
    case UnitTransferReasonEnumType.Death:
      return 'Death of the investor';
    case UnitTransferReasonEnumType.Disability:
      return 'Disability of the investor';
    case UnitTransferReasonEnumType.EntityRestructuring:
      return 'Entity restructuring';
    case UnitTransferReasonEnumType.FamilyOfficeRestructuring:
      return 'Family office restructuring';
    case UnitTransferReasonEnumType.SaleOfUnits:
      return 'Sale of units';
    case UnitTransferReasonEnumType.Other:
      return 'Other';
    default:
      return reason;
  }
}
